import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";

export default function Location({ content }) {
  const email = (content?.email || "").replace(",com", ".com");
  return (
    <section id="location" data-testid="location-section" className="py-24 lg:py-32 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661] mb-4">Come as you are</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1C201E] leading-tight">
            {content?.heading || "Location & Contact"}
          </h2>

          <ul className="mt-10 space-y-6">
            <li className="flex gap-4">
              <MapPin className="w-5 h-5 mt-1 text-[#D4A373] shrink-0" />
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661]">Address</div>
                <div data-testid="location-address" className="mt-1 text-[#1C201E]">{content?.address}</div>
              </div>
            </li>
            {content?.phone && <li className="flex gap-4">
              <Phone aria-hidden="true" className="w-5 h-5 mt-1 text-[#D4A373] shrink-0" />
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661]">Phone</div>
                <a data-testid="location-phone" href={`tel:${content.phone}`} className="mt-1 block rounded-sm text-[#1C201E] hover:text-[#2C4C3B]">{content.phone}</a>
              </div>
            </li>}
            <li className="flex gap-4">
              <Mail aria-hidden="true" className="w-5 h-5 mt-1 text-[#D4A373] shrink-0" />
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#5C6661]">Email</div>
                <a data-testid="location-email" href={`mailto:${email}`} className="mt-1 block rounded-sm break-all text-[#1C201E] hover:text-[#2C4C3B]">{email}</a>
              </div>
            </li>
          </ul>

          <a
            href={content?.directions_url}
            target="_blank"
            rel="noreferrer"
            data-testid="location-directions"
            className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#2C4C3B] text-white text-sm hover:bg-[#1A3326] transition-colors duration-200"
          >
            Get Directions <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-3xl overflow-hidden border border-[#E5E0D8] shadow-[0_20px_60px_rgba(0,0,0,0.05)] aspect-[4/3]">
            <iframe
              data-testid="location-map"
              title="Church Location"
              src={content?.map_embed}
              className="w-full h-full"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
